import { ReportsDisplayer } from "pages/reports/components/ReportsDisplayer"
import { ReportTypeEnum } from "pages/reports/interfaces/reports.interfaces"
import { ClpTableEnum } from "components/ClpTable/ClpTableEnum"

const index = () => {
  return (
    <ReportsDisplayer reportType={ReportTypeEnum.User} tableId={ClpTableEnum.UserReports} />
  )
}

export default index